export default "__VITE_ASSET__BSWAci1b__"